<template>
  <footer class="app-footer">
    <div class="container">
      <p class="footer-text">
        Powered by 
        <a 
          href="https://www.spotify.com" 
          target="_blank" 
          rel="noopener noreferrer"
          class="spotify-link"
        >
          Spotify
        </a>
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Keine Logik erforderlich
</script>

<style scoped lang="scss">
.app-footer {
  @apply fixed bottom-0 left-0 right-0;
  background: rgba($background-dark, 0.9);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba($spotify-gray, 0.2);
  z-index: $z-footer;
  padding: $spacing-md $spacing-lg;
}

.container {
  @apply max-w-screen-xl mx-auto;
  @apply flex items-center justify-center;
}

.footer-text {
  @apply text-sm text-gray-400 m-0;
}

.spotify-link {
  @apply text-green-500 font-semibold no-underline;
  @apply hover:text-green-400;
  @apply transition-colors duration-300;
  color: $spotify-green;
  
  &:hover {
    color: lighten($spotify-green, 10%);
  }
}
</style>